import { fieldsConflictMessage } from "graphql/validation/rules/OverlappingFieldsCanBeMerged"
import {
  UPDATE_LANGUAGE,
  UPDATE_FORM,
  UPDATE_FIELD,
  UPDATE_SECTION,
  HIDE_BUTTON,
  UPDATE_CAPTCHA_STATUS,
  SET_LOADER,
  REMOVE_ERROR,
  CUSTOM_ERROR,
  UPDATE_SHOW_SECTION,
} from "../contants/action-types"
import cloneDeep from "lodash/cloneDeep"
import conditionsAggregator from "./conditionsAggregator"

export interface KeyValuePair {
  key: string
  value: any
}

export interface IReduxState {
  fields: any
  conditionFields: any
  conditions: any
  fieldValues: any
  hideButton: boolean
  JssFormKey: any
  captcha: boolean
  showsection: boolean
  removeError: boolean
  customError: string
}

export interface IReduxAction {
  type: string
  payload: any
}

const initialState = {
  originalFields: [],
  fields: [],
  conditionFields: [],
  conditions: [],
  fieldValues: [],
  hideButton: false,
  JssFormKey: null,
  captcha: false,
  loader: false,
  showsection: false,
  removeError: false,
  customError: ""
}

function rootReducer(state = initialState, action: IReduxAction) {
  switch (action.type) {
    case UPDATE_LANGUAGE: {
      let ActionPayload = action.payload
      let aggregator =
        ActionPayload.fields[1].fields &&
        new conditionsAggregator(ActionPayload.fields[1].fields)

      return Object.assign({}, state, {
        originalFields: cloneDeep(action.payload), //Object.assign({},state.originalFields,JSON.parse(JSON.stringify(action.payload))),
        fields: cloneDeep(action.payload), //Object.assign({},state.fields,JSON.parse(JSON.stringify(action.payload))),
        conditionFields: Object.assign(
          {},
          state.conditionFields,
          aggregator?.conditionFields
        ),
        conditions: Object.assign({}, state.conditions, aggregator?.conditions),
        fieldValues: Object.assign(
          {},
          state.fieldValues,
          aggregator?.fieldValues
        ),
        JssFormKey: Object.assign(
          {},
          state.JssFormKey,
          Math.floor(Math.random() * 10000)
        ),
      })
    }
    case HIDE_BUTTON: {
      return { ...state, hideButton: !state.hideButton }
    }

    case SET_LOADER: {
      return { ...state, loader: action.payload }
    }
    case UPDATE_FORM: {
      return Object.assign({}, state, {
        conditionFields: action.payload.conditionFields,
        conditions: action.payload.conditions,
        fieldValues: action.payload.fieldValues,
      })
    }
    case UPDATE_FIELD: {
      return Object.assign({}, state, {
        fieldValues: action.payload,
      })
    }

    case REMOVE_ERROR: {
      return { ...state, removeError: action.payload }
    }

    case CUSTOM_ERROR: {
      return {...state, customError: action.payload}
    }
    case UPDATE_SECTION: {
      let MutatedFieldCollection = state.fields["fields"][1]["fields"]
      let originalFieldsCollection1 =
        state.originalFields["fields"][1]["fields"]
      let matchedSection = undefined
      const findSectionField = (array, sectionName) => {
        for (let field of array) {
          if (field.model.name === sectionName) {
            return field
          }
          if (field.hasOwnProperty("fields") && field.fields.length > 0) {
            for (let innerField of field.fields) {
              if (innerField.model.name === sectionName) {
                return innerField
              }
            }
          }
        }

        return null
      }
      let mutatedSection = findSectionField(
        MutatedFieldCollection,
        action.payload.name
      )
      if (action.payload.IsVisible) {
        let section = findSectionField(
          originalFieldsCollection1,
          action.payload.name
        )
        if (mutatedSection) {
          mutatedSection["fields"] = cloneDeep(section["fields"])
        }
      } else {
        if (mutatedSection) {
          mutatedSection["fields"].length = 0
        }
      }

      // let Newfields = state.fields;
      // let originalFieldsCollection = state.originalFields["fields"][1]["fields"];
      // let fieldCollection = Newfields["fields"][1]["fields"];
      // let oldsection = fieldCollection.find((field) =>  field.model.name === action.payload.name);
      // let index = fieldCollection.indexOf(oldsection);
      // if(action.payload.name == 'SectionCustomerBrands')
      // debugger;

      // if(action.payload.IsVisible)
      // {
      //     let section  = state.originalFields["fields"][1]["fields"].find((field) =>  field.model.name === action.payload.name);
      //     if (index !== -1) {
      //       fieldCollection[index]["fields"] = [...section["fields"]];
      //   }

      // }
      // else
      // {
      //   if (index !== -1) {
      //   fieldCollection[index]["fields"].length = 0;
      //   }
      // }

      state.fields["fields"][1]["fields"] = [...MutatedFieldCollection]

      return {
        ...state,
        fields: state.fields,
      }
    }

    case UPDATE_CAPTCHA_STATUS: {
      return { ...state, captcha: action.payload }
    }

    case UPDATE_SHOW_SECTION: {
      return { ...state, showsection: action.payload }
    }
    default: {
      return state
    }
  }
}

export default rootReducer
